"use strict";
import React from "react";
import classNames from "classnames";
const GhostBlock = (props) => {
  return /* @__PURE__ */ React.createElement("div", { className: classNames("ghost-block", props.className), style: props.style });
};
export default GhostBlock;
